import styled from "styled-components";
// import { Link as RouterLink } from 'react-router-dom'
import { ArrowBack } from "@styled-icons/boxicons-regular/ArrowBack";
import media from "styled-media-query";
import Spinner from "components/Spinner";
import Popup from "reactjs-popup";

export const DivModalValidPhoto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
`;

export const RadioGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 30px;
`;

export const Header = styled.div`
  line-height: ${({
    theme: {
      lineHeight: { lineHeightUL },
    },
  }) => lineHeightUL};
  align-items: center;
  margin-bottom: ${({
    theme: {
      spacings: { medium },
    },
  }) => medium};
`;

export const IconArrow = styled(ArrowBack)`
  width: 20px;
  height: 23px;
  position: absolute;

  path {
    fill: ${({
      theme: {
        colors: { gray },
      },
    }) => gray};
  }
`;

export const TextBold = styled.p`
  text-align: left;
  line-height: ${({
    theme: {
      lineHeight: { lineHeightUL },
    },
  }) => lineHeightUL};
  margin-bottom: ${({
    theme: {
      spacings: { xxlarge },
    },
  }) => xxlarge};
  font-size: ${({
    theme: {
      sizes: { small },
    },
  }) => small};
  font-weight: ${({
    theme: {
      fontWeight: { fontWeightSemiBold },
    },
  }) => fontWeightSemiBold};
  color: ${({
    theme: {
      colors: { blackLight },
    },
  }) => blackLight};

  ${media.greaterThan("medium")`
    font-size: ${({
      theme: {
        sizes: { medium },
      },
    }) => medium};
  `}
`;

export const TextBoldRef = styled.p`
  text-align: left;
  line-height: ${({
    theme: {
      lineHeight: { lineHeightUL },
    },
  }) => lineHeightUL};
  margin-bottom: 5%;
  font-size: ${({
    theme: {
      sizes: { small },
    },
  }) => small};
  font-weight: ${({
    theme: {
      fontWeight: { fontWeightSemiBold },
    },
  }) => fontWeightSemiBold};
  color: ${({
    theme: {
      colors: { blackLight },
    },
  }) => blackLight};

  ${media.greaterThan("medium")`
    font-size: ${({
      theme: {
        sizes: { medium },
      },
    }) => medium};
  `}
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: ${({
    theme: {
      sizes: { small },
    },
  }) => small};
  font-weight: ${({
    theme: {
      fontWeight: { fontWeightRegular },
    },
  }) => fontWeightRegular};
  color: ${({
    theme: {
      colors: { blackLight },
    },
  }) => blackLight};

  ${media.greaterThan("medium")`
    font-size: ${({
      theme: {
        sizes: { medium },
      },
    }) => medium};
  `}
`;

export const WrapperCamera = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;

  visibility: ${({ show }) => (show ? "visible" : "hidden")};
`;

export const Picture = styled.div`
  grid-area: camera;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0;

  @media screen and (max-width: 500px) {
    justify-content: center;
  }

  #picture-modal {
    margin-right: 20px;
  }

  button {
    display: flex;
    align-items: center;
    width: auto !important;
    height: 40px !important;
    margin: 0 20px 0 0 !important;
    svg {
      margin-right: 10px;
    }
  }
`;

export const ErrorMessage = styled.span`
  color: ${({
    theme: {
      colors: { red },
    },
  }) => red};
  font-size: 1.5rem;
`;

export const SuccessMessage = styled.span`
  color: ${({
    theme: {
      colors: { green },
    },
  }) => green};
  font-size: 1.5rem;
  text-align: center;
`;

export const SpinnerCusmotized = styled(Spinner).attrs((props) => ({
  color: props.theme.colors.primary,
}))``;

export const WrapperSpinner = styled.div`
  width: 200px;
  height: 200px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomPopup = styled(Popup)`
  &-content {
    border-radius: 10px;
    .container {
      padding: 1.5rem;
      text-align: center;

      p {
        font-size: 2rem;
        margin-bottom: 1rem;
      }
      span {
        margin: 1rem;
        font-size: 1.5rem;
        font-weight: 600;
      }

      .counterContainer {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;

export const Loader2 = styled.div`
  .lds-default {
    display: inline-block;
    position: relative;
    width: 150px;
    height: 150px;
  }
  .lds-default div {
    position: absolute;
    width: 12px;
    height: 12px;
    background: #e71037;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
  }
  .lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 74px;
    left: 132px;
  }
  .lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 44px;
    left: 124px;
  }
  .lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 22px;
    left: 104px;
  }
  .lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 14px;
    left: 74px;
  }
  .lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 22px;
    left: 44px;
  }
  .lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 44px;
    left: 22px;
  }
  .lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 74px;
    left: 14px;
  }
  .lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 104px;
    left: 22px;
  }
  .lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 124px;
    left: 44px;
  }
  .lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 132px;
    left: 74px;
  }
  .lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 124px;
    left: 104px;
  }
  .lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 104px;
    left: 124px;
  }
  @keyframes lds-default {
    0%,
    20%,
    80%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
  }
`;
